import * as React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
// import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  backgroundColor: "transparent !important",
  // padding: "10px 13px !important",
  // padding: theme.spacing(2),
  textAlign: "center",
  // color: theme.palette.text.secondary,
}));

const theme = createTheme();

theme.typography.h4 = {
  fontSize: "25px",
  "@media (min-width:600px)": {
    fontSize: "26px",
  },
};
theme.typography.h6 = {
  fontSize: "15px",
  "@media (min-width:600px)": {
    fontSize: "16px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "16px",
  },
};
theme.typography.body1 = {
  fontSize: "16px",
  "@media (min-width:600px)": {
    fontSize: "19px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "19px",
  },
};

const ProjectsCard = ({ projects , isLoading}) => {
  const url = `/project/${projects?.id}`;

  // console.log(projects)
  return (
    <Grid item xs={4} sm={4} md={4}>
      <ThemeProvider theme={theme}>
      {isLoading && <CircularProgress />}
        <Card className="CardBG customboxshadow" sx={{ boxShadow: 4 }}>
          {/* <Link to={url}>Details</Link> */}
          <Link to={url}>
            <CardMedia
              height="220px"
              width="100%"
              component="img"
              sx={{ mx: "auto" }}
              image={projects?.image}
              alt="green iguana"
            />
            <CardContent>
              <Typography
                variant="h4"
                className="cardtextwhite"
                sx={{ textAlign: "center" }}
              >
                {projects?.title}
              </Typography>
              {/* <Divider variant="middle" /> */}
              <hr />
              <Typography
                variant="body1"
                color="text.primary"
                className="cardtextwhite"
                sx={{ pb: 2 }}
              >
                {projects?.description}
                {/* {projects?.description.slice(0, 200)} */}
              </Typography>
              <Typography
                variant="h6"
                className="cardtextwhite bordercolor"
                // className="cardtextwhite button-beguni"
                sx={{ textAlign: "center", py: 1, mb: 1 }}
              >
                {projects?.technologies}
              </Typography>
            </CardContent>
          </Link>

          <CardContent sx={{ pt:1 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs>
                  <Item>
                    {" "}
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      target="_blank"
                      href={projects?.visit}
                      rel="noreferrer"
                    >
                      <Button className="button-beguni" variant="contained">
                        Live Demo
                      </Button>
                    </a>
                  </Item>
                </Grid>
                <Grid item xs>
                  <Item>
                    {" "}
                    <a
                      style={{ textDecoration: "none", color: "white" }}
                      target="_blank"
                      href={projects?.client}
                      rel="noreferrer"
                    >
                      <Button className="button-beguni" variant="contained">
                        Client Code
                      </Button>
                    </a>
                  </Item>
                </Grid>
                {projects?.server && (
                  <Grid item xs>
                    <Item>
                      {" "}
                      <a
                        style={{ textDecoration: "none", color: "white" }}
                        target="_blank"
                        href={projects?.server}
                        rel="noreferrer"
                      >
                        <Button className="button-beguni" variant="contained">
                          Server Code
                        </Button>
                      </a>
                    </Item>
                  </Grid>
                )}
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </ThemeProvider>
    </Grid>
  );
};

export default ProjectsCard;
